/**
 * Single gate consulted by every `canvas.toJSON()` persistence path.
 *
 * Live-canvas preview mutates object transforms frame by frame. Anything that
 * serializes the live canvas while preview is active would persist
 * mid-animation state into canvasData, permanently corrupting the design.
 * The preview player owns this flag; savers only read it.
 */

let previewActive = false;

/** True while the live canvas is showing animated (non-authored) state. */
export function isPreviewActive(): boolean {
  return previewActive;
}

/** Set by the preview player on enter/exit. */
export function setPreviewActive(on: boolean): void {
  previewActive = on;
}
